<div class="toggle-card" [class.selected]="item.selected" (click)="onCardClick()">
  <div class="card-info">
    <span class="card-name">{{ item.name }}</span>
  </div>
  <div class="card-toggle" (click)="$event.stopPropagation()">
    <mat-slide-toggle [(ngModel)]="item.visible" (change)="onToggleChange()">
    </mat-slide-toggle>
  </div>
</div>
